Vue.http.headers.common['X-CSRF-TOKEN'] = $('#_token').val();

export default class Request {
    constructor() {
        this.token = null;
        this.apiBase = '/api/v2';
        this.ajaxBase = '/design.beta/';
    }

    get(url, params, opts, successCallback, failureCallback) {
        this.__getWithOpts(url, params, opts, successCallback, failureCallback);
    };

    __getWithOpts(url, params, headers, successCallback, failureCallback) {
        Vue.http.get(url, params, {headers: headers}).then(successCallback, failureCallback);
    }

    post(url, data, successCallback, failureCallback) {
        this.__postWithOpts(url, data, {}, successCallback, failureCallback);
    };

    __postWithOpts(url, data, headers, successCallback, failureCallback) {
        Vue.http.post(url, data, {headers: headers}).then(successCallback, failureCallback);
    }

    oAuthGet(url, params, successCallback, failureCallback) {
        this.__getWithOpts(url, params, this._getHeaders(), successCallback, failureCallback);
    };

    oAuthPost(url, data, successCallback, failureCallback) {
        this.__postWithOpts(url, data, this._getHeaders(), successCallback, failureCallback);
    };

    oAuthToken(callback) {
        if (this.token == null) {
            var form = new FormData();
            form.append("grant_type", "client_credentials");
            form.append("client_id", "frontend");
            form.append("client_secret", "frontend");
            form.append("scope", "public");
            this.__postWithOpts('/api/v2/token', form, {}, (response) => {
                this.token = response.data;
                callback(response.data);
            }, function (response) {

            });
        } else {
            callback(this.token);
        }
    };

    getToken() {
        return this.token;
    };

    _getHeaders() {
        return {
            'authorization': `${this.token.token_type} ${this.token.access_token}`
        };
    }
}


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/services/RequestService.js